import type { ListedFork } from "@gearbox-protocol/deploy-tools-shared";
import { Plus } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { useMemo } from "react";
import { Link, useLoaderData } from "react-router-dom";

import ForkList from "./ForkList";

const ForkListRoute: FC = () => {
  const forks = useLoaderData() as ListedFork[];

  const [active, inactive, paused] = useMemo(() => {
    const [act, inact, paused]: ListedFork[][] = [[], [], []];
    for (const fork of forks) {
      if (fork.paused) {
        paused.push(fork);
      } else {
        (fork.isActive ? act : inact).push(fork);
      }
    }
    return [act, inact, paused];
  }, [forks]);

  return (
    <div className="flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4">
      <ForkList
        forks={active}
        title={
          <div className="flex flex-row gap-2 items-center">
            <h2 className="text-gray-100">Active forks</h2>
            <Link to="/new-fork">
              <Plus />
            </Link>
          </div>
        }
        className="text-gray-100"
      />
      {paused.length > 0 && (
        <ForkList
          forks={paused}
          title={<h2 className="text-gray-300">Paused forks</h2>}
          className="text-gray-300"
        />
      )}
      {inactive.length > 0 && (
        <ForkList
          forks={inactive}
          title={<h2 className="text-gray-300">Dead forks</h2>}
          className="text-gray-300"
        />
      )}
    </div>
  );
};

export default ForkListRoute;
